import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import { ModalService } from 'ui-components/services/modal-service';
import { ErrorState, WarningState } from 'ui-components/prop-types/error-warning-info';

import Global from '../store/global-selectors';
import { emptyObject } from 'ui-components/default-props/empty';
import { bulkRequestEntities } from '../store/entities/entities.actions';
import * as OrdersApi from '../store/orders/orders.api';
// TODO: move the methods to the right service
import { ErrorModal } from '../components/modals/error-modal';
import { requestOrderDetails } from '../store/orders/order-details/orders.details.actions';
import { syncCswToEntities } from '../store/csw/csw.actions';
import * as Actions from './actions';
import messages from './messages';
import {
  getUserFriendlyMessagesForErrorResponse,
  getWordErrorDescriptor,
  getUnknownErrorDescriptor,
} from '../errors/user-friendly-error-message-service';

const launchErrorModal = (title, message, action, state = ErrorState) => {
  ModalService.launchModal({
    component: ErrorModal,
    props: {
      state,
      action,
      title,
      message,
    },
  });
};

export const updateShipTo = (action$) => {
  return action$.pipe(
    ofType(Actions.UPDATE_SALES_ORDER_SHIP_TO),
    mergeMap((action) => {
      const { salesOrderId, address } = action;
      if (!salesOrderId || !address) {
        return EMPTY;
      }
      return OrdersApi.updateShipTo(address, salesOrderId).pipe(
        mergeMap(({ data }) => {
          const hasUpdateWarnings = data.updateWarnings.length > 0;

          if (hasUpdateWarnings) {
            const { errors } = getUserFriendlyMessagesForErrorResponse({
              Errors: data.updateWarnings,
            });
            const shipToError = errors[0];
            const { messageDescriptor, values } = shipToError;
            launchErrorModal(
              <FormattedMessage {...messages.editShipToWarningTitle} />,
              <FormattedMessage {...messageDescriptor} values={values} />,
              null,
              WarningState,
            );
          }
          return concat(of(syncCswToEntities()), of(bulkRequestEntities({ salesOrderIds: [salesOrderId] })), of(requestOrderDetails()));
        }),
        catchError(() => {
          launchErrorModal(<FormattedMessage {...getWordErrorDescriptor()} />, <FormattedMessage {...getUnknownErrorDescriptor()} />);
          return EMPTY;
        }),
      );
    }),
  );
};

// sequentially execute sold to and ship to updates because of the way the backend handles updating the db
export const updateShipToAndSoldTo = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.UPDATE_SALES_ORDER_SHIP_TO_AND_SOLD_TO),
    mergeMap(({ salesOrderId, address, email }) => {
      if (!salesOrderId) {
        return EMPTY;
      }
      const soldTo =
        Global.selectEntitiesSalesOrderProperty(getState(), {
          salesOrderId,
          property: 'soldTo',
        }) || emptyObject;
      const { name, phone } = soldTo;
      return OrdersApi.updateSoldTo(
        {
          email,
          name,
          phone,
        },
        salesOrderId,
      ).pipe(
        catchError(() => {
          return of({});
        }),
        mergeMap(() => {
          return of(Actions.updateSalesOrderShipTo({ salesOrderId, address }));
        }),
      );
    }),
  );
};
